import { FDCDisciplines } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const disciplines = CreateViewEditSoftRemoveRestore({
  page: FDCDisciplines,
  object: 'Discipline',
  view: '36f7b0f7-dc87-45ad-bdb6-c204b0a579af',
  create: '3aeee96d-8c08-4d94-a255-286443f8b361',
  edit: 'd4b18ac6-e0cc-4308-908f-8d1c6639ebf8',
  removeRestore: '6c7c1214-42da-422d-8007-78232864161d',
})

export const ViewFDCDiscipline = disciplines.View
export const CreateFDCDiscipline = disciplines.Create
export const EditFDCDiscipline = disciplines.Edit
export const RemoveRestoreFDCDiscipline = disciplines.RemoveRestore

export type FDCDisciplinePermission =
  | typeof ViewFDCDiscipline
  | typeof CreateFDCDiscipline
  | typeof EditFDCDiscipline
  | typeof RemoveRestoreFDCDiscipline
